import { TotalResultsCount } from '@app/core/components/TotalResultsCount';
import { Box } from '@mui/material';
import { CopyUrlButton } from './actions/CopyUrlButton';
import { ExportButton } from './actions/ExportButton';
import { RefreshButton } from './actions/RefreshButton';

/**
 * Actions bar component that groups action buttons together.
 */
export function ActionsBar({
  actions,
  onExport,
  onRefresh,
  total,
  isLoading,
}: {
  actions: React.ReactNode[];
  onExport?: (format: 'csv' | 'xls') => Promise<unknown>;
  onRefresh: () => void;
  total: number;
  isLoading: boolean;
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        gap: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <RefreshButton onRefresh={onRefresh} />
        <TotalResultsCount count={total} isLoading={isLoading} />
      </Box>
      <Box sx={{ display: 'flex', gap: 1.5 }}>
        {actions}
        <CopyUrlButton />
        {onExport && <ExportButton onExport={onExport} />}
      </Box>
    </Box>
  );
}
